// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZlaGXH-3tB5vO\\+ {\n  padding: 0 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": "ZlaGXH-3tB5vO+"
};
export default ___CSS_LOADER_EXPORT___;
